/** @jsx jsx */
import { jsx } from '@emotion/core'
import { HFlow, Text, useTheme } from 'bold-ui'
import { DateTime } from 'components/date'
import { AtendimentoProfissional } from 'graphql/types.generated'
import { ReactComponent as ContinuousMedicineIcon } from 'images/medical/medicine-continuous-bicolor.svg'

interface PrescricaoRenovadaLabelProps {
  atendProf: AtendimentoProfissional
}

export function PrescricaoRenovadaLabel(props: Readonly<PrescricaoRenovadaLabelProps>) {
  const { atendProf } = props
  const theme = useTheme()

  return (
    <HFlow hSpacing={0.5}>
      <ContinuousMedicineIcon fill={theme.pallete.primary.main} width='1rem' height='1rem' />
      <Text fontWeight='bold'>
        Prescrição renovada em <DateTime value={atendProf.iniciadoEm} format='DD/MM/YYYY [às] HH:mm' />
        {' por '}
        {atendProf.lotacao.profissional.nome}
      </Text>
    </HFlow>
  )
}
